import GridReporte from './grid-cancel-report';
import Modal from '../modals/modal';
import React from 'react';
import ReporteFiltros from './modal-cancel-filtros';
import { ErpConnect as qad } from '../../../services';
import Swal from 'sweetalert2';



class ModalCancel extends React.Component {
  
  state = {
    dataGrid: [],
    loading: false,
  };

  handleBuscar = async () => {
    this.setState({
      loading: true,
    });
    try 
    {
      const datos = await qad.catalog.salesOrder.listForDelete();
      console.log(datos);
      this.setState({
        dataGrid: datos,
        loading: false,
      });
    } catch (e) {
      console.log(e);
    }
  };

  handleToDelete = async () => {
    // ejecucion de busqueda
    this.setState({
      loading: true,
    });
    const statusChangedArray = this.state.dataGrid.filter((item)=> item["haveChanged"] && item["haveChanged"] );
    if ( statusChangedArray.length > 0 )
    {
      await qad.catalog.salesOrder.notToDelete( { 
        "data" : statusChangedArray.map((item) => { 
          return{ "salesOrderId" : item.salesOrderId, "notDelete" : item.noDelete } 
        } ) } );
    }
    else
    {
      Swal.fire({
          title: 'No se selecciono ningúna Remision',
          html: 'Nada que Guardar'
        })
    }
    this.setState({
      loading: false,
    });
  };

  

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.isOpen}
          onClose={() => {
            this.props.onClose();
          }}
        >
          <ReporteFiltros
            onBuscar={this.handleBuscar}
            toDelete={this.handleToDelete}
            disableToDelete={this.state.loading || this.state.dataGrid.length < 1}
          />
          <br />
          {this.state.loading ? (
            <div className="loader"></div>
          ) : (
            <GridReporte
              data={this.state.dataGrid}
              onBuscar={this.handleBuscar}
            />
            
            
          )}

          
    
        </Modal>
      </React.Fragment>
    );
  }
}
export default ModalCancel;
